module.exports = "<mat-checkbox [checked]=\"value\" disabled></mat-checkbox>\r\n"